module.exports = __webpack_public_path__ + "img/1437571264.4bd68bf2.jpg";